function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var email = require('./email');
var _require = require('./transactions'),
  createMigrationPayoutTransaction = _require.createMigrationPayoutTransaction,
  createBuySaitoPayoutTransaction = _require.createBuySaitoPayoutTransaction,
  restoreSavedSignedTransaction = _require.restoreSavedSignedTransaction;
var _require2 = require('./buysaito'),
  storePurchaseMessage = _require2.storePurchaseMessage,
  storePurchaseRecipient = _require2.storePurchaseRecipient;

// Outbound SAITO payouts complete after one included block by default.
// Required N means the confirmation height is inclusion + (N - 1).
function outboundConfirmationBlockId(blockId, required) {
  var need = Number(required);
  var threshold = Number.isFinite(need) && need > 0 ? need : 1;
  return Number(blockId) + Math.max(0, threshold - 1);
}
function asBlockId(value) {
  if (typeof value === 'bigint') {
    return Number(value);
  }
  var blockId = Number(value);
  if (!Number.isInteger(blockId) || blockId < 0 || !Number.isSafeInteger(blockId)) {
    return null;
  }
  return blockId;
}

// Store purchases only. A Mixin deposit observation is evidence that the
// reserved address was paid. It does not apply BuySaito's quote match or
// migration's positive-amount allocation, and it does not wait for additional
// confirmations.
function storePurchaseDeposit(row, observation) {
  if (!observation) {
    return null;
  }
  var reserved = Number(row.inbound_amount);
  var enough = function enough(amount) {
    return amount > 0 && (!Number.isFinite(reserved) || reserved <= 0 || amount + 1e-9 >= reserved);
  };
  var found = [];
  var _iterator = _createForOfIteratorHelper(observation.snapshots || []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _snapshot$deposit, _snapshot$deposit2;
      var snapshot = _step.value;
      var destination = (snapshot === null || snapshot === void 0 || (_snapshot$deposit = snapshot.deposit) === null || _snapshot$deposit === void 0 ? void 0 : _snapshot$deposit.destination) || (snapshot === null || snapshot === void 0 ? void 0 : snapshot.receiver) || '';
      if (!destination || destination !== row.inbound_address) {
        continue;
      }
      found.push({
        hash: snapshot.transaction_hash || '',
        id: snapshot.snapshot_id || '',
        sender: ((_snapshot$deposit2 = snapshot.deposit) === null || _snapshot$deposit2 === void 0 ? void 0 : _snapshot$deposit2.sender) || '',
        amount: Number(snapshot.amount)
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(observation.deposits || []),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var deposit = _step2.value;
      if (deposit !== null && deposit !== void 0 && deposit.destination && deposit.destination !== row.inbound_address) {
        continue;
      }
      found.push({
        hash: deposit.transaction_hash || '',
        id: deposit.deposit_id || deposit.transaction_id || '',
        sender: deposit.sender || '',
        amount: Number(deposit.amount)
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return found.find(function (item) {
    return item.hash && enough(item.amount);
  }) || null;
}
var OPEN_STATUSES = ['inbound_awaiting', 'inbound_broadcast', 'inbound_confirmed', 'outbound_awaiting', 'outbound_broadcast', 'treasury_submitted', 'treasury_accepted'];
var Transfers = /*#__PURE__*/function () {
  function Transfers(app, mod) {
    var _this$mod;
    _classCallCheck(this, Transfers);
    this.app = app;
    this.mod = mod;
    this.running = false;
    this.inclusion_checked = false;
    // Shared unpaid reservation window for BuySaito, Store purchases, and Migration.
    // Duration comes from Mixin.ADDRESS_RESERVATION_PERIOD_IN_MINUTES.
    this.reservation_ms = Number(((_this$mod = this.mod) === null || _this$mod === void 0 ? void 0 : _this$mod.ADDRESS_RESERVATION_PERIOD_IN_MINUTES) || 40) * 60 * 1000;
  }

  // outbound_confirmed is the completed SAITO inclusion. `succeeded` stays in the
  // schema for older rows and has no separate evidence, so this queue does not
  // write it.
  return _createClass(Transfers, [{
    key: "longestChainHashAtId",
    value: function () {
      var _longestChainHashAtId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(blockId) {
        var _this$app$blockchain;
        var id, hash, _hash, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              id = asBlockId(blockId);
              if (!(id === null || typeof ((_this$app$blockchain = this.app.blockchain) === null || _this$app$blockchain === void 0 ? void 0 : _this$app$blockchain.getLongestChainHashAtId) !== 'function')) {
                _context.n = 1;
                break;
              }
              return _context.a(2, '');
            case 1:
              _context.p = 1;
              _context.n = 2;
              return this.app.blockchain.getLongestChainHashAtId(BigInt(id));
            case 2:
              hash = _context.v;
              return _context.a(2, hash == null ? '' : String(hash));
            case 3:
              _context.p = 3;
              _t = _context.v;
              _context.p = 4;
              _context.n = 5;
              return this.app.blockchain.getLongestChainHashAtId(id);
            case 5:
              _hash = _context.v;
              return _context.a(2, _hash == null ? '' : String(_hash));
            case 6:
              _context.p = 6;
              _t2 = _context.v;
              return _context.a(2, '');
          }
        }, _callee, this, [[4, 6], [1, 3]]);
      }));
      function longestChainHashAtId(_x) {
        return _longestChainHashAtId.apply(this, arguments);
      }
      return longestChainHashAtId;
    }()
  }, {
    key: "processTransferQueue",
    value: function () {
      var _processTransferQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var options,
          _this$app$blockchain2,
          now,
          observations,
          observed,
          _iterator3,
          _step3,
          _row5,
          evidence,
          match,
          confirmed,
          next,
          _this$mod$creditDepos2,
          _this$mod4,
          allocated,
          _this$mod$creditDepos,
          _this$mod3,
          _claimed,
          claimed,
          _this$mod$notifyBrows2,
          _this$mod5,
          _this$mod$creditDepos3,
          _this$mod6,
          _claimed2,
          detected,
          _iterator4,
          _step4,
          _row6,
          _match,
          _iterator5,
          _step5,
          _this$mod$notifyBrows3,
          _this$mod7,
          _row7,
          _detected,
          currentBlockId,
          floorBlockId,
          _this$app$blockchain3,
          candidates,
          awaitingSigned,
          broadcastSigned,
          _i,
          _arr,
          row,
          wanted,
          latestId,
          id,
          hash,
          block,
          _iterator6,
          _step6,
          tx,
          _row,
          blockId,
          _require3,
          forwardTreasuryPayout,
          _iterator7,
          _step7,
          _row2,
          _iterator8,
          _step8,
          _row3,
          _iterator9,
          _step9,
          _row8,
          _iterator0,
          _step0,
          _this$mod$notifyBrows,
          _this$mod2,
          _row4,
          canonical,
          issued,
          _args2 = arguments,
          _t3,
          _t4,
          _t5,
          _t6,
          _t7,
          _t8,
          _t9,
          _t0,
          _t1,
          _t10,
          _t11,
          _t12,
          _t13,
          _t14,
          _t15,
          _t16,
          _t17,
          _t18,
          _t19,
          _t20,
          _t21,
          _t22,
          _t23,
          _t24;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              if (!this.running) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.running = true;
              _context2.p = 2;
              now = Date.now();
              _context2.n = 3;
              return this.fetchInboundMixinPayments();
            case 3:
              observations = _context2.v;
              observed = new Map(observations.map(function (item) {
                return [item.transfer_id, item];
              }));
              _t3 = _createForOfIteratorHelper;
              _context2.n = 4;
              return this.mod.database.getTransfersPendingInboundBroadcast();
            case 4:
              _iterator3 = _t3(_context2.v);
              _context2.p = 5;
              _iterator3.s();
            case 6:
              if ((_step3 = _iterator3.n()).done) {
                _context2.n = 25;
                break;
              }
              _row5 = _step3.value;
              if (!_row5.outbound_tx_sig) {
                _context2.n = 7;
                break;
              }
              return _context2.a(3, 24);
            case 7:
              if (!(['buysaito', 'store-purchase', 'migration'].includes(_row5.purpose) && Number(_row5.created_at) < now - this.reservation_ms)) {
                _context2.n = 9;
                break;
              }
              _context2.n = 8;
              return this.mod.database.updateTransfer(_row5.id, {
                status: 'failed'
              });
            case 8:
              return _context2.a(3, 24);
            case 9:
              if (!(_row5.purpose === 'store-purchase')) {
                _context2.n = 11;
                break;
              }
              evidence = storePurchaseDeposit(_row5, observed.get(_row5.id));
              if (!evidence) {
                _context2.n = 10;
                break;
              }
              _context2.n = 10;
              return this.recordStorePurchaseInboundPayment(_row5, evidence);
            case 10:
              return _context2.a(3, 24);
            case 11:
              match = this.findMatchingInboundPayment(_row5, observed.get(_row5.id));
              if (match !== null && match !== void 0 && match.hash) {
                _context2.n = 12;
                break;
              }
              return _context2.a(3, 24);
            case 12:
              confirmed = match.confirmations >= Number(_row5.inbound_confirmations_required || 0);
              next = confirmed ? 'inbound_confirmed' : 'inbound_broadcast';
              if (!(_row5.purpose === 'migration')) {
                _context2.n = 21;
                break;
              }
              allocated = void 0;
              _context2.p = 13;
              // Migration only. The payout is the received amount, and amounts above
              // the migration cap are refused. BuySaito uses its reservation quote
              // instead, so this cap must not be applied to other purposes.
              allocated = this.mod.migration.allocationForDeposit(match.amount);
              _context2.n = 18;
              break;
            case 14:
              _context2.p = 14;
              _t4 = _context2.v;
              _context2.n = 15;
              return this.claimObservedInboundPayment(_row5, {
                status: 'failed',
                last_error: _t4.message,
                inbound_tx_hash: match.hash
              });
            case 15:
              _claimed = _context2.v;
              if (_claimed) {
                _context2.n = 16;
                break;
              }
              return _context2.a(3, 24);
            case 16:
              email.sendStatusEmail(this.app, 0, _objectSpread(_objectSpread({}, _row5), {}, {
                inbound_amount: match.amount
              }), _t4.message);
              _context2.n = 17;
              return email.sendFailureNotice(this.app, _row5.recipient_publickey || _row5.requester_publickey, this.mod);
            case 17:
              (_this$mod$creditDepos = (_this$mod3 = this.mod).creditDepositAddress) === null || _this$mod$creditDepos === void 0 || _this$mod$creditDepos.call(_this$mod3, _row5.inbound_address, match.amount, match.hash);
              return _context2.a(3, 24);
            case 18:
              _context2.n = 19;
              return this.claimObservedInboundPayment(_row5, {
                status: next,
                inbound_amount: String(allocated),
                outbound_amount: String(allocated),
                outbound_ticker: 'SAITO',
                inbound_tx_hash: match.hash,
                inbound_tx_id: match.id || '',
                inbound_sender: match.sender || _row5.inbound_sender,
                inbound_confirmations: match.confirmations,
                inbound_received_at: _row5.inbound_received_at || now,
                last_error: ''
              });
            case 19:
              claimed = _context2.v;
              if (claimed) {
                _context2.n = 20;
                break;
              }
              return _context2.a(3, 24);
            case 20:
              (_this$mod$creditDepos2 = (_this$mod4 = this.mod).creditDepositAddress) === null || _this$mod$creditDepos2 === void 0 || _this$mod$creditDepos2.call(_this$mod4, _row5.inbound_address, match.amount, match.hash);
              return _context2.a(3, 24);
            case 21:
              if (!(_row5.purpose === 'buysaito')) {
                _context2.n = 24;
                break;
              }
              _context2.n = 22;
              return this.claimObservedInboundPayment(_row5, {
                status: next,
                inbound_tx_hash: match.hash,
                inbound_tx_id: match.id,
                inbound_sender: match.sender,
                inbound_confirmations: match.confirmations,
                inbound_received_at: _row5.inbound_received_at || now
              });
            case 22:
              _claimed2 = _context2.v;
              if (_claimed2) {
                _context2.n = 23;
                break;
              }
              return _context2.a(3, 24);
            case 23:
              detected = {
                id: _row5.id,
                address: _row5.inbound_address,
                ticker: _row5.inbound_ticker,
                status: next === 'inbound_confirmed' ? 'confirmed' : 'pending',
                initiator_pubkey: _row5.requester_publickey
              };
              (_this$mod$notifyBrows2 = (_this$mod5 = this.mod).notifyBrowser) === null || _this$mod$notifyBrows2 === void 0 || _this$mod$notifyBrows2.call(_this$mod5, 'buysaito payment detected', detected, _row5.requester_publickey);
              this.app.connection.emit('saito-purchase-payment-detected', detected);
              (_this$mod$creditDepos3 = (_this$mod6 = this.mod).creditDepositAddress) === null || _this$mod$creditDepos3 === void 0 || _this$mod$creditDepos3.call(_this$mod6, _row5.inbound_address, match.amount || _row5.inbound_amount, match.hash);
            case 24:
              _context2.n = 6;
              break;
            case 25:
              _context2.n = 27;
              break;
            case 26:
              _context2.p = 26;
              _t5 = _context2.v;
              _iterator3.e(_t5);
            case 27:
              _context2.p = 27;
              _iterator3.f();
              return _context2.f(27);
            case 28:
              _t6 = _createForOfIteratorHelper;
              _context2.n = 29;
              return this.mod.database.getTransfers({
                status: 'inbound_broadcast',
                mode: 'automatic',
                excluded: 0
              });
            case 29:
              _iterator4 = _t6(_context2.v);
              _context2.p = 30;
              _iterator4.s();
            case 31:
              if ((_step4 = _iterator4.n()).done) {
                _context2.n = 39;
                break;
              }
              _row6 = _step4.value;
              if (!_row6.outbound_tx_sig) {
                _context2.n = 32;
                break;
              }
              return _context2.a(3, 38);
            case 32:
              if (!(_row6.purpose === 'store-purchase')) {
                _context2.n = 33;
                break;
              }
              return _context2.a(3, 38);
            case 33:
              _match = this.findMatchingInboundPayment(_row6, observed.get(_row6.id));
              if (_match) {
                _context2.n = 34;
                break;
              }
              return _context2.a(3, 38);
            case 34:
              if (!(_row6.purpose === 'migration')) {
                _context2.n = 37;
                break;
              }
              if (!(_row6.inbound_tx_hash && _match.hash && _match.hash !== _row6.inbound_tx_hash)) {
                _context2.n = 35;
                break;
              }
              return _context2.a(3, 38);
            case 35:
              _context2.n = 36;
              return this.claimObservedInboundPayment(_row6, {
                inbound_tx_hash: _match.hash || _row6.inbound_tx_hash,
                inbound_tx_id: _match.id || _row6.inbound_tx_id,
                inbound_sender: _match.sender || _row6.inbound_sender,
                inbound_confirmations: _match.confirmations
              });
            case 36:
              return _context2.a(3, 38);
            case 37:
              if (!(_row6.purpose === 'buysaito')) {
                _context2.n = 38;
                break;
              }
              _context2.n = 38;
              return this.claimObservedInboundPayment(_row6, {
                inbound_tx_hash: _match.hash || _row6.inbound_tx_hash,
                inbound_tx_id: _match.id || _row6.inbound_tx_id,
                inbound_sender: _match.sender || _row6.inbound_sender,
                inbound_confirmations: _match.confirmations
              });
            case 38:
              _context2.n = 31;
              break;
            case 39:
              _context2.n = 41;
              break;
            case 40:
              _context2.p = 40;
              _t7 = _context2.v;
              _iterator4.e(_t7);
            case 41:
              _context2.p = 41;
              _iterator4.f();
              return _context2.f(41);
            case 42:
              _t8 = _createForOfIteratorHelper;
              _context2.n = 43;
              return this.mod.database.getTransfersPendingInboundConfirmed();
            case 43:
              _iterator5 = _t8(_context2.v);
              _context2.p = 44;
              _iterator5.s();
            case 45:
              if ((_step5 = _iterator5.n()).done) {
                _context2.n = 49;
                break;
              }
              _row7 = _step5.value;
              _context2.n = 46;
              return this.mod.database.updateTransfer(_row7.id, {
                status: 'inbound_confirmed'
              });
            case 46:
              if (!(_row7.purpose !== 'buysaito')) {
                _context2.n = 47;
                break;
              }
              return _context2.a(3, 48);
            case 47:
              _detected = {
                id: _row7.id,
                address: _row7.inbound_address,
                ticker: _row7.inbound_ticker,
                status: 'confirmed',
                initiator_pubkey: _row7.requester_publickey
              };
              (_this$mod$notifyBrows3 = (_this$mod7 = this.mod).notifyBrowser) === null || _this$mod$notifyBrows3 === void 0 || _this$mod$notifyBrows3.call(_this$mod7, 'buysaito payment detected', _detected, _row7.requester_publickey);
              this.app.connection.emit('saito-purchase-payment-detected', _detected);
            case 48:
              _context2.n = 45;
              break;
            case 49:
              _context2.n = 51;
              break;
            case 50:
              _context2.p = 50;
              _t9 = _context2.v;
              _iterator5.e(_t9);
            case 51:
              _context2.p = 51;
              _iterator5.f();
              return _context2.f(51);
            case 52:
              // A missing or unusable block id skips issuance and outbound confirmation.
              // It is not replaced with block 0, which would authorize a threshold of 0.
              currentBlockId = null;
              if (!(typeof ((_this$app$blockchain2 = this.app.blockchain) === null || _this$app$blockchain2 === void 0 ? void 0 : _this$app$blockchain2.getLatestBlockId) === 'function')) {
                _context2.n = 56;
                break;
              }
              _context2.p = 53;
              _t0 = asBlockId;
              _context2.n = 54;
              return this.app.blockchain.getLatestBlockId();
            case 54:
              currentBlockId = _t0(_context2.v);
              _context2.n = 56;
              break;
            case 55:
              _context2.p = 55;
              _t1 = _context2.v;
              currentBlockId = null;
            case 56:
              floorBlockId = asBlockId(options.floorBlockId);
              if (floorBlockId !== null) {
                currentBlockId = currentBlockId === null ? floorBlockId : Math.max(currentBlockId, floorBlockId);
              }
              if (this.inclusion_checked) {
                _context2.n = 85;
                break;
              }
              candidates = [];
              _context2.n = 57;
              return this.mod.database.getTransfersPendingOutboundBroadcast();
            case 57:
              awaitingSigned = _context2.v;
              _context2.n = 58;
              return this.mod.database.getTransfers({
                status: 'outbound_broadcast'
              });
            case 58:
              broadcastSigned = _context2.v;
              for (_i = 0, _arr = [].concat(_toConsumableArray(awaitingSigned || []), _toConsumableArray(broadcastSigned || [])); _i < _arr.length; _i++) {
                row = _arr[_i];
                if (row.outbound_tx_sig && !row.outbound_block_hash) {
                  candidates.push(row);
                }
              }
              if (!(!((_this$app$blockchain3 = this.app.blockchain) !== null && _this$app$blockchain3 !== void 0 && _this$app$blockchain3.getLatestBlockId) || !candidates.length)) {
                _context2.n = 59;
                break;
              }
              this.inclusion_checked = true;
              _context2.n = 85;
              break;
            case 59:
              wanted = new Map(candidates.map(function (row) {
                return [row.outbound_tx_sig, row];
              }));
              _context2.p = 60;
              _t11 = asBlockId;
              _context2.n = 61;
              return this.app.blockchain.getLatestBlockId();
            case 61:
              _t10 = _t11(_context2.v);
              if (_t10) {
                _context2.n = 62;
                break;
              }
              _t10 = 0;
            case 62:
              latestId = _t10;
              id = latestId;
            case 63:
              if (!(id > 0 && wanted.size)) {
                _context2.n = 83;
                break;
              }
              hash = '';
              block = null;
              _context2.p = 64;
              _context2.n = 65;
              return this.longestChainHashAtId(id);
            case 65:
              hash = _context2.v;
              if (hash) {
                _context2.n = 66;
                break;
              }
              return _context2.a(3, 82);
            case 66:
              _context2.n = 67;
              return this.app.blockchain.loadBlockAsync(String(hash));
            case 67:
              block = _context2.v;
              if (!(!block && this.app.blockchain.getBlock)) {
                _context2.n = 69;
                break;
              }
              _context2.n = 68;
              return this.app.blockchain.getBlock(String(hash), true);
            case 68:
              block = _context2.v;
            case 69:
              _context2.n = 71;
              break;
            case 70:
              _context2.p = 70;
              _t12 = _context2.v;
              return _context2.a(3, 82);
            case 71:
              if (block) {
                _context2.n = 72;
                break;
              }
              return _context2.a(3, 82);
            case 72:
              _iterator6 = _createForOfIteratorHelper(block.transactions || []);
              _context2.p = 73;
              _iterator6.s();
            case 74:
              if ((_step6 = _iterator6.n()).done) {
                _context2.n = 79;
                break;
              }
              tx = _step6.value;
              _row = wanted.get(tx === null || tx === void 0 ? void 0 : tx.signature);
              if (_row) {
                _context2.n = 75;
                break;
              }
              return _context2.a(3, 78);
            case 75:
              blockId = asBlockId(block.id);
              if (!(blockId === null)) {
                _context2.n = 76;
                break;
              }
              return _context2.a(3, 78);
            case 76:
              _context2.n = 77;
              return this.mod.database.updateTransfer(_row.id, {
                outbound_block_id: blockId,
                outbound_block_hash: String(block.hash || hash),
                outbound_confirmation_block_id: outboundConfirmationBlockId(blockId, _row.outbound_confirmations_required),
                status: 'outbound_broadcast'
              });
            case 77:
              wanted["delete"](tx.signature);
            case 78:
              _context2.n = 74;
              break;
            case 79:
              _context2.n = 81;
              break;
            case 80:
              _context2.p = 80;
              _t13 = _context2.v;
              _iterator6.e(_t13);
            case 81:
              _context2.p = 81;
              _iterator6.f();
              return _context2.f(81);
            case 82:
              id--;
              _context2.n = 63;
              break;
            case 83:
              this.inclusion_checked = true;
              _context2.n = 85;
              break;
            case 84:
              _context2.p = 84;
              _t14 = _context2.v;
              console.error('Mixin transfer inclusion check failed:', _t14);
            case 85:
              if (!(this.mod.payout_mode === 'remote')) {
                _context2.n = 96;
                break;
              }
              _require3 = require('./treasury'), forwardTreasuryPayout = _require3.forwardTreasuryPayout;
              _t15 = _createForOfIteratorHelper;
              _context2.n = 86;
              return this.mod.database.getTransfersPendingTreasurySubmission();
            case 86:
              _iterator7 = _t15(_context2.v);
              _context2.p = 87;
              _iterator7.s();
            case 88:
              if ((_step7 = _iterator7.n()).done) {
                _context2.n = 93;
                break;
              }
              _row2 = _step7.value;
              _context2.p = 89;
              _context2.n = 90;
              return forwardTreasuryPayout(this.mod, _row2);
            case 90:
              _context2.n = 92;
              break;
            case 91:
              _context2.p = 91;
              _t16 = _context2.v;
              console.error("Mixin transfer ".concat(_row2.id, " treasury submission failed:"), _t16);
            case 92:
              _context2.n = 88;
              break;
            case 93:
              _context2.n = 95;
              break;
            case 94:
              _context2.p = 94;
              _t17 = _context2.v;
              _iterator7.e(_t17);
            case 95:
              _context2.p = 95;
              _iterator7.f();
              return _context2.f(95);
            case 96:
              if (!(currentBlockId !== null)) {
                _context2.n = 107;
                break;
              }
              _t18 = _createForOfIteratorHelper;
              _context2.n = 97;
              return this.mod.database.getTransfersPendingOutboundAwaiting(currentBlockId);
            case 97:
              _iterator8 = _t18(_context2.v);
              _context2.p = 98;
              _iterator8.s();
            case 99:
              if ((_step8 = _iterator8.n()).done) {
                _context2.n = 104;
                break;
              }
              _row3 = _step8.value;
              _context2.p = 100;
              _context2.n = 101;
              return this.issueOutboundTransfer(_row3);
            case 101:
              _context2.n = 103;
              break;
            case 102:
              _context2.p = 102;
              _t19 = _context2.v;
              console.error("Mixin transfer ".concat(_row3.id, " issuance failed:"), _t19);
            case 103:
              _context2.n = 99;
              break;
            case 104:
              _context2.n = 106;
              break;
            case 105:
              _context2.p = 105;
              _t20 = _context2.v;
              _iterator8.e(_t20);
            case 106:
              _context2.p = 106;
              _iterator8.f();
              return _context2.f(106);
            case 107:
              _t21 = _createForOfIteratorHelper;
              _context2.n = 108;
              return this.mod.database.getTransfersPendingOutboundBroadcast();
            case 108:
              _iterator9 = _t21(_context2.v);
              _context2.p = 109;
              _iterator9.s();
            case 110:
              if ((_step9 = _iterator9.n()).done) {
                _context2.n = 112;
                break;
              }
              _row8 = _step9.value;
              if (!_row8.outbound_block_hash) {
                _context2.n = 111;
                break;
              }
              _context2.n = 111;
              return this.mod.database.updateTransfer(_row8.id, {
                status: 'outbound_broadcast'
              });
            case 111:
              _context2.n = 110;
              break;
            case 112:
              _context2.n = 114;
              break;
            case 113:
              _context2.p = 113;
              _t22 = _context2.v;
              _iterator9.e(_t22);
            case 114:
              _context2.p = 114;
              _iterator9.f();
              return _context2.f(114);
            case 115:
              if (!(currentBlockId !== null)) {
                _context2.n = 130;
                break;
              }
              _t23 = _createForOfIteratorHelper;
              _context2.n = 116;
              return this.mod.database.getTransfersPendingOutboundConfirmed(currentBlockId);
            case 116:
              _iterator0 = _t23(_context2.v);
              _context2.p = 117;
              _iterator0.s();
            case 118:
              if ((_step0 = _iterator0.n()).done) {
                _context2.n = 127;
                break;
              }
              _row4 = _step0.value;
              _context2.n = 119;
              return this.longestChainHashAtId(_row4.outbound_block_id);
            case 119:
              canonical = _context2.v;
              if (!(canonical && canonical !== String(_row4.outbound_block_hash || ''))) {
                _context2.n = 121;
                break;
              }
              _context2.n = 120;
              return this.mod.database.updateTransfer(_row4.id, {
                status: 'outbound_awaiting',
                outbound_block_id: null,
                outbound_block_hash: '',
                outbound_confirmation_block_id: null
              });
            case 120:
              return _context2.a(3, 126);
            case 121:
              if (!(!canonical && !options.trustInclusion)) {
                _context2.n = 122;
                break;
              }
              return _context2.a(3, 126);
            case 122:
              _context2.n = 123;
              return this.mod.database.updateTransfer(_row4.id, {
                status: 'outbound_confirmed'
              });
            case 123:
              if (!(_row4.purpose === 'migration')) {
                _context2.n = 124;
                break;
              }
              email.sendStatusEmail(this.app, 2, _row4, "TX Signature: ".concat(_row4.outbound_tx_sig, "</p><p>Block ID: ").concat(_row4.outbound_block_id));
              return _context2.a(3, 126);
            case 124:
              if (!(_row4.purpose !== 'buysaito')) {
                _context2.n = 125;
                break;
              }
              return _context2.a(3, 126);
            case 125:
              issued = {
                id: _row4.id,
                address: _row4.inbound_address,
                ticker: _row4.inbound_ticker,
                initiator_pubkey: _row4.requester_publickey,
                recipient_pubkey: _row4.recipient_publickey,
                issue_amount: _row4.outbound_amount,
                paid: _row4.outbound_tx_sig,
                status: 'confirmed'
              };
              (_this$mod$notifyBrows = (_this$mod2 = this.mod).notifyBrowser) === null || _this$mod$notifyBrows === void 0 || _this$mod$notifyBrows.call(_this$mod2, 'buysaito saito issued', issued, _row4.requester_publickey);
              this.app.connection.emit('saito-purchase-saito-issued', issued);
            case 126:
              _context2.n = 118;
              break;
            case 127:
              _context2.n = 129;
              break;
            case 128:
              _context2.p = 128;
              _t24 = _context2.v;
              _iterator0.e(_t24);
            case 129:
              _context2.p = 129;
              _iterator0.f();
              return _context2.f(129);
            case 130:
              _context2.n = 131;
              return this.rebroadcastSavedOutboundTransfers();
            case 131:
              _context2.p = 131;
              this.running = false;
              return _context2.f(131);
            case 132:
              return _context2.a(2);
          }
        }, _callee2, this, [[117, 128, 129, 130], [109, 113, 114, 115], [100, 102], [98, 105, 106, 107], [89, 91], [87, 94, 95, 96], [73, 80, 81, 82], [64, 70], [60, 84], [53, 55], [44, 50, 51, 52], [30, 40, 41, 42], [13, 14], [5, 26, 27, 28], [2,, 131, 132]]);
      }));
      function processTransferQueue() {
        return _processTransferQueue.apply(this, arguments);
      }
      return processTransferQueue;
    }()
  }, {
    key: "fetchInboundMixinPayments",
    value: function () {
      var _fetchInboundMixinPayments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var awaiting, broadcast, rows, bundles, memory, privateKey, stored, _iterator1, _step1, saved, cache, observations, _iterator10, _step10, row, credentials, key, deposits, snapshots, _t25, _t26, _t27;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.n = 1;
              return this.mod.database.getTransfers({
                status: 'inbound_awaiting',
                mode: 'automatic',
                excluded: 0
              });
            case 1:
              awaiting = _context3.v;
              _context3.n = 2;
              return this.mod.database.getTransfers({
                status: 'inbound_broadcast',
                mode: 'automatic',
                excluded: 0
              });
            case 2:
              broadcast = _context3.v;
              rows = [].concat(_toConsumableArray(awaiting), _toConsumableArray(broadcast));
              if (rows.length) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2, []);
            case 3:
              bundles = new Map();
              memory = this.mod.accounts.getCredentials();
              if (memory !== null && memory !== void 0 && memory.user_id) {
                bundles.set(memory.user_id, memory);
              }
              privateKey = '';
              _context3.p = 4;
              _context3.n = 5;
              return this.app.wallet.getPrivateKey();
            case 5:
              privateKey = _context3.v;
              _context3.n = 7;
              break;
            case 6:
              _context3.p = 6;
              _t25 = _context3.v;
              privateKey = '';
            case 7:
              _context3.n = 8;
              return this.mod.database.getCredentials(this.mod.publicKey);
            case 8:
              stored = _context3.v;
              _iterator1 = _createForOfIteratorHelper(stored || []);
              _context3.p = 9;
              _iterator1.s();
            case 10:
              if ((_step1 = _iterator1.n()).done) {
                _context3.n = 13;
                break;
              }
              saved = _step1.value;
              if (!(!saved.user_id || bundles.has(saved.user_id) || !privateKey)) {
                _context3.n = 11;
                break;
              }
              return _context3.a(3, 12);
            case 11:
              try {
                bundles.set(saved.user_id, this.mod.accounts.decryptCredentials(saved.ciphertext, privateKey));
              } catch (err) {
                console.error("Mixin credentials for ".concat(saved.user_id, " could not be decrypted:"), err);
              }
            case 12:
              _context3.n = 10;
              break;
            case 13:
              _context3.n = 15;
              break;
            case 14:
              _context3.p = 14;
              _t26 = _context3.v;
              _iterator1.e(_t26);
            case 15:
              _context3.p = 15;
              _iterator1.f();
              return _context3.f(15);
            case 16:
              cache = new Map();
              observations = [];
              _iterator10 = _createForOfIteratorHelper(rows);
              _context3.p = 17;
              _iterator10.s();
            case 18:
              if ((_step10 = _iterator10.n()).done) {
                _context3.n = 24;
                break;
              }
              row = _step10.value;
              credentials = bundles.get(row.inbound_mixin_user_id);
              if (credentials) {
                _context3.n = 19;
                break;
              }
              observations.push({
                transfer_id: row.id,
                deposits: [],
                snapshots: []
              });
              return _context3.a(3, 23);
            case 19:
              key = "".concat(row.inbound_mixin_user_id, ":").concat(row.inbound_asset_id, ":").concat(row.inbound_address);
              if (cache.has(key)) {
                _context3.n = 22;
                break;
              }
              _context3.n = 20;
              return this.mod.api.fetchDeposits(credentials, row.inbound_asset_id, row.inbound_address);
            case 20:
              deposits = _context3.v;
              _context3.n = 21;
              return this.mod.api.fetchHistory(credentials, row.inbound_asset_id, row.created_at);
            case 21:
              snapshots = _context3.v;
              cache.set(key, {
                deposits: deposits === false ? [] : deposits || [],
                snapshots: snapshots === false ? [] : snapshots || []
              });
            case 22:
              observations.push(_objectSpread({
                transfer_id: row.id
              }, cache.get(key)));
            case 23:
              _context3.n = 18;
              break;
            case 24:
              _context3.n = 26;
              break;
            case 25:
              _context3.p = 25;
              _t27 = _context3.v;
              _iterator10.e(_t27);
            case 26:
              _context3.p = 26;
              _iterator10.f();
              return _context3.f(26);
            case 27:
              return _context3.a(2, observations);
          }
        }, _callee3, this, [[17, 25, 26, 27], [9, 14, 15, 16], [4, 6]]);
      }));
      function fetchInboundMixinPayments() {
        return _fetchInboundMixinPayments.apply(this, arguments);
      }
      return fetchInboundMixinPayments;
    }()
  }, {
    key: "claimObservedInboundPayment",
    value: function () {
      var _claimObservedInboundPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(row, fields) {
        var _result$conflict;
        var result, ownerId, message;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.mod.database.claimInboundPayment(row.id, fields);
            case 1:
              result = _context4.v;
              if (!(result !== null && result !== void 0 && result.ok)) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, true);
            case 2:
              ownerId = result === null || result === void 0 || (_result$conflict = result.conflict) === null || _result$conflict === void 0 ? void 0 : _result$conflict.id;
              message = row.purpose === 'migration' ? 'Migration deposit was already recorded' : "Inbound payment ".concat(fields.inbound_tx_hash, " is already claimed by transfer ").concat(ownerId);
              _context4.n = 3;
              return this.mod.database.updateTransfer(row.id, {
                last_error: message
              });
            case 3:
              return _context4.a(2, false);
          }
        }, _callee4, this);
      }));
      function claimObservedInboundPayment(_x2, _x3) {
        return _claimObservedInboundPayment.apply(this, arguments);
      }
      return claimObservedInboundPayment;
    }()
  }, {
    key: "findMatchingInboundPayment",
    value: function findMatchingInboundPayment(row, observation) {
      if (!observation) {
        return null;
      }
      // Store purchases only. Inbound evidence is recorded by
      // recordStorePurchaseInboundPayment. BuySaito and migration matching
      // must not accept or reject these rows.
      if (row.purpose === 'store-purchase') {
        return null;
      }
      var required = Number(row.inbound_confirmations_required || 0);
      // Migration only. A deposit matches the reserved destination address. The
      // received amount is allocated 1:1. BuySaito matches a quoted amount instead,
      // so this positive-amount rule must not be applied to another purpose.
      if (row.purpose === 'migration' && this.mod.migration) {
        var _iterator11 = _createForOfIteratorHelper(observation.snapshots || []),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var _snapshot$deposit3, _snapshot$deposit4;
            var snapshot = _step11.value;
            var destination = (snapshot === null || snapshot === void 0 || (_snapshot$deposit3 = snapshot.deposit) === null || _snapshot$deposit3 === void 0 ? void 0 : _snapshot$deposit3.destination) || (snapshot === null || snapshot === void 0 ? void 0 : snapshot.receiver) || '';
            if (!destination || destination !== row.inbound_address) {
              continue;
            }
            var amount = Number(snapshot.amount);
            if (!(amount > 0)) {
              continue;
            }
            return {
              hash: snapshot.transaction_hash || '',
              id: snapshot.snapshot_id || '',
              sender: ((_snapshot$deposit4 = snapshot.deposit) === null || _snapshot$deposit4 === void 0 ? void 0 : _snapshot$deposit4.sender) || '',
              amount: amount,
              confirmations: Number(snapshot.confirmations || 0)
            };
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
        var _iterator12 = _createForOfIteratorHelper(observation.deposits || []),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var deposit = _step12.value;
            if (deposit !== null && deposit !== void 0 && deposit.destination && deposit.destination !== row.inbound_address) {
              continue;
            }
            var _amount = Number(deposit.amount);
            if (!(_amount > 0)) {
              continue;
            }
            return {
              hash: deposit.transaction_hash || '',
              id: deposit.deposit_id || deposit.transaction_id || '',
              sender: deposit.sender || '',
              amount: _amount,
              confirmations: Number(deposit.confirmations || 0)
            };
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
        return null;
      }
      // BuySaito only. The observed deposit must reach the quoted inbound_amount
      // reserved for this transfer. Migration accepts the received amount, so
      // this minimum must not be applied to migration or another purpose.
      if (row.purpose !== 'buysaito') {
        return null;
      }
      var _iterator13 = _createForOfIteratorHelper(observation.snapshots),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _snapshot$deposit5, _snapshot$deposit6;
          var _snapshot = _step13.value;
          var address = (_snapshot === null || _snapshot === void 0 || (_snapshot$deposit5 = _snapshot.deposit) === null || _snapshot$deposit5 === void 0 ? void 0 : _snapshot$deposit5.destination) || (_snapshot === null || _snapshot === void 0 ? void 0 : _snapshot.receiver) || '';
          if (!address || address !== row.inbound_address) {
            continue;
          }
          if (Number(_snapshot === null || _snapshot === void 0 ? void 0 : _snapshot.amount) < Number(row.inbound_amount)) {
            continue;
          }
          return {
            hash: _snapshot.transaction_hash || '',
            id: _snapshot.snapshot_id || '',
            sender: ((_snapshot$deposit6 = _snapshot.deposit) === null || _snapshot$deposit6 === void 0 ? void 0 : _snapshot$deposit6.sender) || '',
            amount: Number(_snapshot.amount),
            confirmations: Math.max(Number(_snapshot.confirmations || 0), required)
          };
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      var _iterator14 = _createForOfIteratorHelper(observation.deposits),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var _deposit = _step14.value;
          if (Number(_deposit === null || _deposit === void 0 ? void 0 : _deposit.amount) < Number(row.inbound_amount)) {
            continue;
          }
          var confirmations = Number(_deposit.confirmations || 0);
          var confirmed = _deposit.status === 'confirmed' || confirmations >= required;
          return {
            hash: _deposit.transaction_hash || '',
            id: _deposit.deposit_id || _deposit.transaction_id || '',
            sender: _deposit.sender || '',
            amount: Number(_deposit.amount),
            confirmations: confirmed ? Math.max(confirmations, required) : confirmations
          };
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      return null;
    }
  }, {
    key: "recordStorePurchaseInboundPayment",
    value: function () {
      var _recordStorePurchaseInboundPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var _yield$this$mod$datab, _this$mod$creditDepos4, _this$mod8, _this$mod$notifyBrows4, _this$mod9, _this$app$connection, _this$app$connection$;
        var evidence,
          hash,
          inboundId,
          sender,
          amount,
          current,
          now,
          claimed,
          _yield$this$mod$datab2,
          updated,
          detected,
          _args5 = arguments,
          _t28,
          _t29,
          _t30,
          _t31,
          _t32,
          _t33,
          _t34,
          _t35;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              evidence = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
              if (!(!row || row.purpose !== 'store-purchase')) {
                _context5.n = 1;
                break;
              }
              throw new Error('That transfer is not a Store purchase.');
            case 1:
              if (!(Number(row.excluded) === 1)) {
                _context5.n = 2;
                break;
              }
              throw new Error('That transfer is excluded from processing.');
            case 2:
              if (!row.outbound_tx_sig) {
                _context5.n = 3;
                break;
              }
              return _context5.a(2, row);
            case 3:
              hash = String(evidence.hash || '').trim();
              inboundId = String(evidence.id || '').trim();
              sender = String(evidence.sender || '').trim();
              amount = Number(evidence.amount);
              if (!(!hash || !(amount > 0))) {
                _context5.n = 4;
                break;
              }
              throw new Error('Store purchase payment evidence is incomplete.');
            case 4:
              _context5.n = 5;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 5:
              _t30 = _yield$this$mod$datab = _context5.v;
              _t29 = _t30 === null;
              if (_t29) {
                _context5.n = 6;
                break;
              }
              _t29 = _yield$this$mod$datab === void 0;
            case 6:
              if (!_t29) {
                _context5.n = 7;
                break;
              }
              _t31 = void 0;
              _context5.n = 8;
              break;
            case 7:
              _t31 = _yield$this$mod$datab[0];
            case 8:
              _t28 = _t31;
              if (_t28) {
                _context5.n = 9;
                break;
              }
              _t28 = row;
            case 9:
              current = _t28;
              if (!(current.inbound_tx_hash && current.inbound_tx_hash !== hash)) {
                _context5.n = 10;
                break;
              }
              return _context5.a(2, current);
            case 10:
              if (!(current.status !== 'inbound_awaiting' && current.inbound_tx_hash === hash)) {
                _context5.n = 11;
                break;
              }
              return _context5.a(2, current);
            case 11:
              if (!(current.status !== 'inbound_awaiting')) {
                _context5.n = 12;
                break;
              }
              throw new Error("Store purchase ".concat(current.id, " cannot be confirmed from status ").concat(current.status, "."));
            case 12:
              now = Date.now();
              _context5.n = 13;
              return this.claimObservedInboundPayment(current, {
                status: 'inbound_confirmed',
                inbound_tx_hash: hash,
                inbound_tx_id: inboundId,
                inbound_sender: sender,
                inbound_amount: String(amount),
                inbound_confirmations: 0,
                inbound_confirmations_required: 0,
                inbound_received_at: current.inbound_received_at || now,
                last_error: ''
              });
            case 13:
              claimed = _context5.v;
              if (claimed) {
                _context5.n = 19;
                break;
              }
              _context5.n = 14;
              return this.mod.database.getTransfers({
                id: current.id
              });
            case 14:
              _t34 = _yield$this$mod$datab2 = _context5.v;
              _t33 = _t34 === null;
              if (_t33) {
                _context5.n = 15;
                break;
              }
              _t33 = _yield$this$mod$datab2 === void 0;
            case 15:
              if (!_t33) {
                _context5.n = 16;
                break;
              }
              _t35 = void 0;
              _context5.n = 17;
              break;
            case 16:
              _t35 = _yield$this$mod$datab2[0];
            case 17:
              _t32 = _t35;
              if (_t32) {
                _context5.n = 18;
                break;
              }
              _t32 = current;
            case 18:
              return _context5.a(2, _t32);
            case 19:
              (_this$mod$creditDepos4 = (_this$mod8 = this.mod).creditDepositAddress) === null || _this$mod$creditDepos4 === void 0 || _this$mod$creditDepos4.call(_this$mod8, current.inbound_address, amount, hash);
              _context5.n = 20;
              return this.mod.database.getTransfers({
                id: current.id
              });
            case 20:
              updated = _context5.v[0];
              detected = {
                id: updated.id,
                address: updated.inbound_address,
                ticker: updated.inbound_ticker,
                status: 'confirmed',
                initiator_pubkey: updated.requester_publickey
              };
              (_this$mod$notifyBrows4 = (_this$mod9 = this.mod).notifyBrowser) === null || _this$mod$notifyBrows4 === void 0 || _this$mod$notifyBrows4.call(_this$mod9, 'buysaito payment detected', detected, updated.requester_publickey);
              (_this$app$connection = this.app.connection) === null || _this$app$connection === void 0 || (_this$app$connection$ = _this$app$connection.emit) === null || _this$app$connection$ === void 0 || _this$app$connection$.call(_this$app$connection, 'saito-purchase-payment-detected', detected);
              return _context5.a(2, updated);
          }
        }, _callee5, this);
      }));
      function recordStorePurchaseInboundPayment(_x4) {
        return _recordStorePurchaseInboundPayment.apply(this, arguments);
      }
      return recordStorePurchaseInboundPayment;
    }()
  }, {
    key: "issueOutboundTransfer",
    value: function () {
      var _issueOutboundTransfer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        var _require4, issueQueuedTreasuryPayout, _require5, forwardTreasuryPayout, amount, required, available, tx, _this$app$core, _this$app$core$getPen, pending, _this$mod$notifyBrows5, _this$mod0, _yield$createBuySaito, _tx, recipient, message, issued, _issued, _tx2, _recipient, _t36, _t37;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (!(!row || row.outbound_tx_sig)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, row);
            case 1:
              if (!(row.purpose === 'store-withdrawal')) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, row);
            case 2:
              if (!(row.purpose === 'treasury-payout')) {
                _context6.n = 4;
                break;
              }
              if (!(this.mod.payout_mode === 'remote')) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2, row);
            case 3:
              _require4 = require('./treasury'), issueQueuedTreasuryPayout = _require4.issueQueuedTreasuryPayout;
              return _context6.a(2, issueQueuedTreasuryPayout(this.mod, row));
            case 4:
              if (!(this.mod.payout_mode === 'remote')) {
                _context6.n = 5;
                break;
              }
              _require5 = require('./treasury'), forwardTreasuryPayout = _require5.forwardTreasuryPayout;
              return _context6.a(2, forwardTreasuryPayout(this.mod, row));
            case 5:
              amount = row.outbound_amount; // Migration only. The stored allocation is checked against the migration cap
              // again before signing. This does not read a new deposit or change the
              // accepted amount. BuySaito signs its reserved quote, so this cap must not
              // be applied to another purpose.
              if (row.purpose === 'migration') {
                amount = this.mod.migration.allocationForDeposit(row.outbound_amount);
              }
              required = this.app.wallet.convertSaitoToNolan(amount);
              _context6.n = 6;
              return this.app.wallet.getBalance();
            case 6:
              available = _context6.v;
              if (!(row.purpose === 'migration')) {
                _context6.n = 14;
                break;
              }
              if (!(typeof available !== 'bigint' || typeof required !== 'bigint' || available < required)) {
                _context6.n = 10;
                break;
              }
              if (!(row.last_error !== 'insufficient_funds')) {
                _context6.n = 8;
                break;
              }
              _context6.n = 7;
              return this.mod.database.updateTransfer(row.id, {
                last_error: 'insufficient_funds'
              });
            case 7:
              email.sendLowBalanceEmail(this.app, row.outbound_amount);
            case 8:
              _context6.n = 9;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 9:
              return _context6.a(2, _context6.v[0]);
            case 10:
              _context6.n = 11;
              return createMigrationPayoutTransaction(this.app, row, amount);
            case 11:
              tx = _context6.v;
              _context6.n = 12;
              return this.mod.database.updateTransfer(row.id, {
                status: 'outbound_awaiting',
                outbound_tx: tx.serialize_to_web(this.app),
                outbound_tx_sig: tx.signature,
                outbound_amount: String(amount),
                outbound_address: row.recipient_publickey,
                outbound_ticker: 'SAITO',
                last_error: ''
              });
            case 12:
              email.sendStatusEmail(this.app, 1, _objectSpread(_objectSpread({}, row), {}, {
                outbound_amount: String(amount)
              }));
              _context6.n = 13;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 13:
              return _context6.a(2, _context6.v[0]);
            case 14:
              if (!(row.purpose === 'buysaito')) {
                _context6.n = 28;
                break;
              }
              if (!(typeof available !== 'bigint' || typeof required !== 'bigint' || required <= 0n)) {
                _context6.n = 15;
                break;
              }
              throw new Error('Invalid payout balance or amount');
            case 15:
              if (!(available < required)) {
                _context6.n = 24;
                break;
              }
              _context6.p = 16;
              _context6.n = 17;
              return (_this$app$core = this.app.core) === null || _this$app$core === void 0 || (_this$app$core = _this$app$core.wallet) === null || _this$app$core === void 0 || (_this$app$core$getPen = _this$app$core.getPendingBalance) === null || _this$app$core$getPen === void 0 ? void 0 : _this$app$core$getPen.call(_this$app$core);
            case 17:
              pending = _context6.v;
              if (!(typeof pending === 'bigint' && pending >= required)) {
                _context6.n = 18;
                break;
              }
              return _context6.a(2, row);
            case 18:
              _context6.n = 20;
              break;
            case 19:
              _context6.p = 19;
              _t36 = _context6.v;
              console.error("Mixin transfer ".concat(row.id, " pending balance check failed:"), _t36);
              return _context6.a(2, row);
            case 20:
              if (!(row.last_error !== 'insufficient_funds')) {
                _context6.n = 22;
                break;
              }
              _context6.n = 21;
              return this.mod.database.updateTransfer(row.id, {
                last_error: 'insufficient_funds'
              });
            case 21:
              (_this$mod$notifyBrows5 = (_this$mod0 = this.mod).notifyBrowser) === null || _this$mod$notifyBrows5 === void 0 || _this$mod$notifyBrows5.call(_this$mod0, 'buysaito report error', {
                code: 'insufficient_funds',
                id: row.id,
                ticker: row.inbound_ticker,
                address: row.inbound_address
              }, row.requester_publickey);
            case 22:
              _context6.n = 23;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 23:
              return _context6.a(2, _context6.v[0]);
            case 24:
              _context6.n = 25;
              return createBuySaitoPayoutTransaction(this.app, row, required);
            case 25:
              _yield$createBuySaito = _context6.v;
              _tx = _yield$createBuySaito.tx;
              recipient = _yield$createBuySaito.recipient;
              _context6.n = 26;
              return this.mod.database.updateTransfer(row.id, {
                status: 'outbound_awaiting',
                outbound_tx: _tx.serialize_to_web(this.app),
                outbound_tx_sig: _tx.signature,
                outbound_address: recipient,
                last_error: ''
              });
            case 26:
              _context6.n = 27;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 27:
              return _context6.a(2, _context6.v[0]);
            case 28:
              if (!(row.purpose === 'store-purchase')) {
                _context6.n = 44;
                break;
              }
              message = storePurchaseMessage(this.app, row.payload);
              if (storePurchaseRecipient(this.app, message)) {
                _context6.n = 31;
                break;
              }
              if (!(row.last_error !== 'Store purchase refund recipient is missing')) {
                _context6.n = 29;
                break;
              }
              _context6.n = 29;
              return this.mod.database.updateTransfer(row.id, {
                last_error: 'Store purchase refund recipient is missing'
              });
            case 29:
              _context6.n = 30;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 30:
              return _context6.a(2, _context6.v[0]);
            case 31:
              if (!(typeof available !== 'bigint' || typeof required !== 'bigint' || required <= 0n)) {
                _context6.n = 32;
                break;
              }
              throw new Error('Invalid payout balance or amount');
            case 32:
              if (!(available < required)) {
                _context6.n = 35;
                break;
              }
              if (!(row.last_error !== 'insufficient_funds')) {
                _context6.n = 33;
                break;
              }
              _context6.n = 33;
              return this.mod.database.updateTransfer(row.id, {
                last_error: 'insufficient_funds'
              });
            case 33:
              _context6.n = 34;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 34:
              return _context6.a(2, _context6.v[0]);
            case 35:
              _context6.p = 35;
              _context6.n = 36;
              return createBuySaitoPayoutTransaction(this.app, row, required);
            case 36:
              issued = _context6.v;
              _context6.n = 41;
              break;
            case 37:
              _context6.p = 37;
              _t37 = _context6.v;
              if (!((_t37 === null || _t37 === void 0 ? void 0 : _t37.message) === 'Store purchase is missing its inbound payment id or transfer id')) {
                _context6.n = 40;
                break;
              }
              if (!(row.last_error !== _t37.message)) {
                _context6.n = 38;
                break;
              }
              _context6.n = 38;
              return this.mod.database.updateTransfer(row.id, {
                last_error: _t37.message
              });
            case 38:
              _context6.n = 39;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 39:
              return _context6.a(2, _context6.v[0]);
            case 40:
              throw _t37;
            case 41:
              _issued = issued, _tx2 = _issued.tx, _recipient = _issued.recipient;
              _context6.n = 42;
              return this.mod.database.updateTransfer(row.id, {
                status: 'outbound_awaiting',
                outbound_tx: _tx2.serialize_to_web(this.app),
                outbound_tx_sig: _tx2.signature,
                outbound_address: _recipient,
                last_error: ''
              });
            case 42:
              _context6.n = 43;
              return this.mod.database.getTransfers({
                id: row.id
              });
            case 43:
              return _context6.a(2, _context6.v[0]);
            case 44:
              // Any purpose other than migration, BuySaito, or a Store purchase. Neither payment constructor
              // applies, so the transfer stays unsigned. This guard must not skip a
              // migration or BuySaito row, and it must not stand in for either purpose's
              // own amount, balance, or reservation rules.
              console.error("Mixin transfer ".concat(row.id, " has no outbound payment for purpose ").concat(row.purpose));
              return _context6.a(2, row);
          }
        }, _callee6, this, [[35, 37], [16, 19]]);
      }));
      function issueOutboundTransfer(_x5) {
        return _issueOutboundTransfer.apply(this, arguments);
      }
      return issueOutboundTransfer;
    }()
  }, {
    key: "rebroadcastSavedOutboundTransfers",
    value: function () {
      var _rebroadcastSavedOutboundTransfers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _iterator15, _step15, row, tx, _t38, _t39, _t40, _t41;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _t38 = _createForOfIteratorHelper;
              _context7.n = 1;
              return this.mod.database.getTransfersPendingOutboundBroadcast();
            case 1:
              _iterator15 = _t38(_context7.v);
              _context7.p = 2;
              _iterator15.s();
            case 3:
              if ((_step15 = _iterator15.n()).done) {
                _context7.n = 13;
                break;
              }
              row = _step15.value;
              if (!row.outbound_block_hash) {
                _context7.n = 4;
                break;
              }
              return _context7.a(3, 12);
            case 4:
              _context7.p = 4;
              tx = restoreSavedSignedTransaction(this.app, row.outbound_tx, row.outbound_tx_sig);
              if (tx) {
                _context7.n = 5;
                break;
              }
              throw new Error("Transfer ".concat(row.id, " has invalid saved issuance data"));
            case 5:
              _context7.p = 5;
              _context7.n = 6;
              return this.app.wallet.addTransactionToPending(tx);
            case 6:
              _context7.n = 8;
              break;
            case 7:
              _context7.p = 7;
              _t39 = _context7.v;
              console.error("Mixin transfer ".concat(row.id, " was already pending:"), _t39);
            case 8:
              _context7.n = 9;
              return this.app.network.propagateTransaction(tx);
            case 9:
              _context7.n = 10;
              return this.mod.database.updateTransfer(row.id, {
                status: 'outbound_broadcast',
                outbound_sent_at: Date.now(),
                last_error: ''
              });
            case 10:
              _context7.n = 12;
              break;
            case 11:
              _context7.p = 11;
              _t40 = _context7.v;
              console.error("Mixin transfer ".concat(row.id, " broadcast failed:"), _t40);
              _context7.n = 12;
              return this.mod.database.updateTransfer(row.id, {
                last_error: String((_t40 === null || _t40 === void 0 ? void 0 : _t40.message) || _t40)
              });
            case 12:
              _context7.n = 3;
              break;
            case 13:
              _context7.n = 15;
              break;
            case 14:
              _context7.p = 14;
              _t41 = _context7.v;
              _iterator15.e(_t41);
            case 15:
              _context7.p = 15;
              _iterator15.f();
              return _context7.f(15);
            case 16:
              return _context7.a(2);
          }
        }, _callee7, this, [[5, 7], [4, 11], [2, 14, 15, 16]]);
      }));
      function rebroadcastSavedOutboundTransfers() {
        return _rebroadcastSavedOutboundTransfers.apply(this, arguments);
      }
      return rebroadcastSavedOutboundTransfers;
    }()
    /**
     * Select an exclusive Mixin deposit address for the given crypto asset.
     * Shared by BuySaito, Store purchases, and Migration. Checks the primary
     * Mixin credentials first, then other decryptable server-owned accounts,
     * skips addresses held by any non-excluded open transfer, and creates an
     * additional Mixin account when none is available.
     */
  }, {
    key: "selectAvailableDepositAddress",
    value: function () {
      var _selectAvailableDepositAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(crypto) {
        var _this = this;
        var privateKey, candidates, memory, _iterator16, _step16, _loop, selected, address, _i2, _candidates, _found, credentials, found, created, rows, _created, _t42, _t43;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              if (crypto !== null && crypto !== void 0 && crypto.asset_id) {
                _context9.n = 1;
                break;
              }
              throw new Error('Deposit asset is not installed');
            case 1:
              _context9.n = 2;
              return this.app.wallet.getPrivateKey();
            case 2:
              privateKey = _context9.v;
              candidates = [];
              memory = this.mod.accounts.getCredentials();
              if (memory !== null && memory !== void 0 && memory.user_id) {
                candidates.push(memory);
              }
              _t42 = _createForOfIteratorHelper;
              _context9.n = 3;
              return this.mod.database.getCredentials(this.mod.publicKey);
            case 3:
              _iterator16 = _t42(_context9.v);
              _context9.p = 4;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var saved;
                return _regenerator().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      saved = _step16.value;
                      if (!candidates.some(function (item) {
                        return item.user_id === saved.user_id;
                      })) {
                        _context8.n = 1;
                        break;
                      }
                      return _context8.a(2, 1);
                    case 1:
                      try {
                        candidates.push(_this.mod.accounts.decryptCredentials(saved.ciphertext, privateKey));
                      } catch (err) {
                        console.error("Mixin credentials for ".concat(saved.user_id, " could not be decrypted:"), err);
                      }
                    case 2:
                      return _context8.a(2);
                  }
                }, _loop);
              });
              _iterator16.s();
            case 5:
              if ((_step16 = _iterator16.n()).done) {
                _context9.n = 8;
                break;
              }
              return _context9.d(_regeneratorValues(_loop()), 6);
            case 6:
              if (!_context9.v) {
                _context9.n = 7;
                break;
              }
              return _context9.a(3, 7);
            case 7:
              _context9.n = 5;
              break;
            case 8:
              _context9.n = 10;
              break;
            case 9:
              _context9.p = 9;
              _t43 = _context9.v;
              _iterator16.e(_t43);
            case 10:
              _context9.p = 10;
              _iterator16.f();
              return _context9.f(10);
            case 11:
              selected = null;
              address = '';
              _i2 = 0, _candidates = candidates;
            case 12:
              if (!(_i2 < _candidates.length)) {
                _context9.n = 20;
                break;
              }
              credentials = _candidates[_i2];
              _context9.n = 13;
              return this.mod.database.findAddress({
                assetId: crypto.asset_id,
                mixinUserId: credentials.user_id
              });
            case 13:
              found = _context9.v;
              if ((_found = found) !== null && _found !== void 0 && _found.address) {
                _context9.n = 16;
                break;
              }
              _context9.n = 14;
              return this.mod.accounts.createAddress(crypto.asset_id, crypto.chain_id, credentials);
            case 14:
              created = _context9.v;
              if (created) {
                _context9.n = 15;
                break;
              }
              return _context9.a(3, 19);
            case 15:
              found = {
                address: created,
                user_id: credentials.user_id
              };
            case 16:
              _context9.n = 17;
              return this.mod.database.getTransfers({
                inbound_address: found.address
              });
            case 17:
              rows = _context9.v;
              if (!rows.some(function (row) {
                return !Number(row.excluded) && OPEN_STATUSES.includes(row.status);
              })) {
                _context9.n = 18;
                break;
              }
              return _context9.a(3, 19);
            case 18:
              selected = credentials;
              address = found.address;
              return _context9.a(3, 20);
            case 19:
              _i2++;
              _context9.n = 12;
              break;
            case 20:
              if (selected) {
                _context9.n = 23;
                break;
              }
              _context9.n = 21;
              return this.mod.accounts.createAccount(this.mod.publicKey, {
                additional: true
              });
            case 21:
              _created = _context9.v;
              selected = this.mod.accounts.decryptCredentials(_created.ciphertext, privateKey);
              _context9.n = 22;
              return this.mod.accounts.createAddress(crypto.asset_id, crypto.chain_id, selected);
            case 22:
              address = _context9.v;
              if (address) {
                _context9.n = 23;
                break;
              }
              throw new Error("Unable to create a ".concat(crypto.ticker || 'deposit', " address"));
            case 23:
              return _context9.a(2, {
                credentials: selected,
                address: address
              });
          }
        }, _callee8, this, [[4, 9, 10, 11]]);
      }));
      function selectAvailableDepositAddress(_x6) {
        return _selectAvailableDepositAddress.apply(this, arguments);
      }
      return selectAvailableDepositAddress;
    }()
    /**
     * Create or return an inbound Mixin deposit-address reservation.
     * Callers supply purpose and all business-specific transfer fields.
     *
     * Note: selectAvailableDepositAddress and insertTransfer are not wrapped in a
     * single DB transaction, and open inbound_address is not uniquely constrained.
     * Concurrent reservations can therefore select the same free address before
     * either insert lands. Hardening that race is deferred.
     */
  }, {
    key: "reserveAddress",
    value: function () {
      var _reserveAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(requesterPublickey) {
        var _this$app$blockchain4;
        var reservation,
          purpose,
          ticker,
          crypto,
          existing,
          open,
          _yield$this$selectAva,
          selected,
          address,
          now,
          inboundConfirmationBlockId,
          raw,
          recipient,
          outboundAddress,
          id,
          _args0 = arguments,
          _t44;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              reservation = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : {};
              purpose = reservation.purpose;
              if (purpose) {
                _context0.n = 1;
                break;
              }
              throw new Error('Transfer purpose is required');
            case 1:
              ticker = reservation.ticker;
              crypto = this.mod.crypto_mods.find(function (item) {
                return item.ticker === ticker;
              });
              if (crypto) {
                _context0.n = 2;
                break;
              }
              throw new Error("Unsupported payment ticker: ".concat(ticker));
            case 2:
              if (!(typeof crypto.returnMixinNetworkInfo === 'function' && (!crypto.last_update || Date.now() - crypto.last_update > 300000))) {
                _context0.n = 3;
                break;
              }
              _context0.n = 3;
              return crypto.returnMixinNetworkInfo();
            case 3:
              _context0.n = 4;
              return this.mod.database.getTransfers({
                requester_publickey: requesterPublickey,
                inbound_ticker: ticker,
                purpose: purpose
              });
            case 4:
              existing = _context0.v;
              open = (existing || []).find(function (row) {
                return !Number(row.excluded) && OPEN_STATUSES.includes(row.status);
              });
              if (!open) {
                _context0.n = 5;
                break;
              }
              return _context0.a(2, this.reservationRecord(open));
            case 5:
              _context0.n = 6;
              return this.selectAvailableDepositAddress(crypto);
            case 6:
              _yield$this$selectAva = _context0.v;
              selected = _yield$this$selectAva.credentials;
              address = _yield$this$selectAva.address;
              now = Date.now();
              if (!(typeof ((_this$app$blockchain4 = this.app.blockchain) === null || _this$app$blockchain4 === void 0 ? void 0 : _this$app$blockchain4.getLatestBlockId) !== 'function')) {
                _context0.n = 7;
                break;
              }
              throw new Error('Saito block height is unavailable');
            case 7:
              _context0.p = 7;
              _context0.n = 8;
              return this.app.blockchain.getLatestBlockId();
            case 8:
              raw = _context0.v;
              inboundConfirmationBlockId = typeof raw === 'bigint' ? Number(raw) : raw;
              _context0.n = 10;
              break;
            case 9:
              _context0.p = 9;
              _t44 = _context0.v;
              throw new Error('Saito block height is unavailable');
            case 10:
              if (!(!Number.isInteger(inboundConfirmationBlockId) || inboundConfirmationBlockId < 0 || !Number.isSafeInteger(inboundConfirmationBlockId))) {
                _context0.n = 11;
                break;
              }
              throw new Error('Saito block height is unavailable');
            case 11:
              recipient = reservation.recipient_publickey || requesterPublickey;
              outboundAddress = reservation.outbound_address || recipient;
              _context0.n = 12;
              return this.mod.database.insertTransfer({
                purpose: purpose,
                mode: 'automatic',
                payload: reservation.payload || '',
                request_id: reservation.request_id || '',
                requester_publickey: requesterPublickey,
                recipient_publickey: recipient,
                status: 'inbound_awaiting',
                inbound_ticker: ticker,
                inbound_asset_id: crypto.asset_id,
                inbound_chain_id: crypto.chain_id || '',
                inbound_amount: reservation.inbound_amount != null ? String(reservation.inbound_amount) : '',
                inbound_address: address,
                inbound_mixin_user_id: selected.user_id,
                inbound_confirmations_required: Number(reservation.inbound_confirmations_required || 0),
                inbound_confirmation_block_id: inboundConfirmationBlockId,
                outbound_ticker: reservation.outbound_ticker || 'SAITO',
                outbound_amount: reservation.outbound_amount != null ? String(reservation.outbound_amount) : '',
                outbound_address: outboundAddress,
                outbound_confirmations_required: Number(reservation.outbound_confirmations_required || 1),
                created_at: now
              });
            case 12:
              id = _context0.v;
              return _context0.a(2, this.reservationRecord({
                id: id,
                purpose: purpose,
                status: 'inbound_awaiting',
                requester_publickey: requesterPublickey,
                recipient_publickey: recipient,
                inbound_ticker: ticker,
                inbound_address: address,
                inbound_mixin_user_id: selected.user_id,
                inbound_amount: reservation.inbound_amount != null ? String(reservation.inbound_amount) : '',
                outbound_amount: reservation.outbound_amount != null ? String(reservation.outbound_amount) : '',
                outbound_tx_sig: '',
                created_at: now
              }));
          }
        }, _callee9, this, [[7, 9]]);
      }));
      function reserveAddress(_x7) {
        return _reserveAddress.apply(this, arguments);
      }
      return reserveAddress;
    }()
  }, {
    key: "reservationRecord",
    value: function reservationRecord(row) {
      return {
        id: row.id,
        purpose: row.purpose,
        status: row.status,
        requester_publickey: row.requester_publickey,
        recipient_publickey: row.recipient_publickey,
        ticker: row.inbound_ticker,
        address: row.inbound_address,
        mixin_id: row.inbound_mixin_user_id,
        inbound_ticker: row.inbound_ticker,
        inbound_address: row.inbound_address,
        inbound_mixin_user_id: row.inbound_mixin_user_id,
        inbound_amount: row.inbound_amount || '',
        outbound_amount: row.outbound_amount || '',
        outbound_tx_sig: row.outbound_tx_sig || '',
        created_at: Number(row.created_at),
        reserved_until: Number(row.created_at) + this.reservation_ms
      };
    }
  }, {
    key: "releaseAddress",
    value: function () {
      var _releaseAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(requesterPublickey, ticker) {
        var purpose,
          rows,
          _iterator17,
          _step17,
          row,
          _args1 = arguments,
          _t45;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              purpose = _args1.length > 2 && _args1[2] !== undefined ? _args1[2] : 'buysaito';
              _context1.n = 1;
              return this.mod.database.getTransfers({
                requester_publickey: requesterPublickey,
                inbound_ticker: ticker,
                purpose: purpose
              });
            case 1:
              rows = _context1.v;
              _iterator17 = _createForOfIteratorHelper(rows);
              _context1.p = 2;
              _iterator17.s();
            case 3:
              if ((_step17 = _iterator17.n()).done) {
                _context1.n = 5;
                break;
              }
              row = _step17.value;
              if (!(row.status === 'inbound_awaiting')) {
                _context1.n = 4;
                break;
              }
              _context1.n = 4;
              return this.mod.database.updateTransfer(row.id, {
                status: 'cancelled'
              });
            case 4:
              _context1.n = 3;
              break;
            case 5:
              _context1.n = 7;
              break;
            case 6:
              _context1.p = 6;
              _t45 = _context1.v;
              _iterator17.e(_t45);
            case 7:
              _context1.p = 7;
              _iterator17.f();
              return _context1.f(7);
            case 8:
              return _context1.a(2);
          }
        }, _callee0, this, [[2, 6, 7, 8]]);
      }));
      function releaseAddress(_x8, _x9) {
        return _releaseAddress.apply(this, arguments);
      }
      return releaseAddress;
    }()
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(block, longestChain) {
        var blockId, signatures, _iterator18, _step18, tx, awaitingSigned, broadcastSigned, _i3, _arr2, row, outboundSig;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              blockId = asBlockId(block === null || block === void 0 ? void 0 : block.id);
              if (!(!longestChain || blockId === null || !Array.isArray(block === null || block === void 0 ? void 0 : block.transactions))) {
                _context10.n = 2;
                break;
              }
              _context10.n = 1;
              return this.processTransferQueue();
            case 1:
              return _context10.a(2);
            case 2:
              signatures = new Map();
              _iterator18 = _createForOfIteratorHelper(block.transactions);
              try {
                for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                  tx = _step18.value;
                  if (tx !== null && tx !== void 0 && tx.signature) {
                    signatures.set(String(tx.signature), tx);
                  }
                }
              } catch (err) {
                _iterator18.e(err);
              } finally {
                _iterator18.f();
              }
              _context10.n = 3;
              return this.mod.database.getTransfersPendingOutboundBroadcast();
            case 3:
              awaitingSigned = _context10.v;
              _context10.n = 4;
              return this.mod.database.getTransfers({
                status: 'outbound_broadcast'
              });
            case 4:
              broadcastSigned = _context10.v;
              _i3 = 0, _arr2 = [].concat(_toConsumableArray(awaitingSigned || []), _toConsumableArray(broadcastSigned || []));
            case 5:
              if (!(_i3 < _arr2.length)) {
                _context10.n = 8;
                break;
              }
              row = _arr2[_i3];
              outboundSig = String(row.outbound_tx_sig || '');
              if (!(!outboundSig || row.outbound_block_hash || !signatures.has(outboundSig))) {
                _context10.n = 6;
                break;
              }
              return _context10.a(3, 7);
            case 6:
              _context10.n = 7;
              return this.mod.database.updateTransfer(row.id, {
                outbound_block_id: blockId,
                outbound_block_hash: String(block.hash || ''),
                outbound_confirmation_block_id: outboundConfirmationBlockId(blockId, row.outbound_confirmations_required)
              });
            case 7:
              _i3++;
              _context10.n = 5;
              break;
            case 8:
              _context10.n = 9;
              return this.observeStoreWithdrawalInclusions(signatures, block);
            case 9:
              _context10.n = 10;
              return this.processTransferQueue({
                floorBlockId: blockId,
                trustInclusion: true
              });
            case 10:
              return _context10.a(2);
          }
        }, _callee1, this);
      }));
      function onNewBlock(_x0, _x1) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "observeStoreWithdrawalInclusions",
    value: function () {
      var _observeStoreWithdrawalInclusions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(signatures, block) {
        var _this$mod$database$li, _this$mod$database;
        var rows, _iterator19, _step19, row, blockId, required, _t46, _t47;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              _context11.n = 1;
              return (_this$mod$database$li = (_this$mod$database = this.mod.database).listStoreWithdrawalsAwaitingInclusion) === null || _this$mod$database$li === void 0 ? void 0 : _this$mod$database$li.call(_this$mod$database);
            case 1:
              rows = _context11.v;
              _iterator19 = _createForOfIteratorHelper(rows || []);
              _context11.p = 2;
              _iterator19.s();
            case 3:
              if ((_step19 = _iterator19.n()).done) {
                _context11.n = 9;
                break;
              }
              row = _step19.value;
              if (!(!row.inbound_tx_sig || !signatures.has(row.inbound_tx_sig))) {
                _context11.n = 4;
                break;
              }
              return _context11.a(3, 8);
            case 4:
              blockId = Number(block.id);
              required = Number(row.inbound_confirmations_required || 0);
              _context11.p = 5;
              _context11.n = 6;
              return this.mod.database.updateTransfer(row.id, {
                inbound_block_id: blockId,
                inbound_block_hash: block.hash || '',
                inbound_confirmation_block_id: blockId + required,
                inbound_longest_chain: 1,
                inbound_confirmations: required === 0 ? 1 : 0
              });
            case 6:
              _context11.n = 8;
              break;
            case 7:
              _context11.p = 7;
              _t46 = _context11.v;
              console.error('Mixin store withdrawal inclusion was not recorded', {
                transfer_id: row.id,
                inbound_tx_sig: row.inbound_tx_sig,
                error: (_t46 === null || _t46 === void 0 ? void 0 : _t46.message) || String(_t46)
              });
            case 8:
              _context11.n = 3;
              break;
            case 9:
              _context11.n = 11;
              break;
            case 10:
              _context11.p = 10;
              _t47 = _context11.v;
              _iterator19.e(_t47);
            case 11:
              _context11.p = 11;
              _iterator19.f();
              return _context11.f(11);
            case 12:
              return _context11.a(2);
          }
        }, _callee10, this, [[5, 7], [2, 10, 11, 12]]);
      }));
      function observeStoreWithdrawalInclusions(_x10, _x11) {
        return _observeStoreWithdrawalInclusions.apply(this, arguments);
      }
      return observeStoreWithdrawalInclusions;
    }()
  }, {
    key: "onChainReorganization",
    value: function () {
      var _onChainReorganization = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(blockId, blockHash, longestChain) {
        var _i4, _arr3, status, _iterator20, _step20, row, _this$mod$database$li2, _this$mod$database2, withdrawals, _iterator21, _step21, _row9, _t48, _t49, _t50, _t51;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              if (!longestChain) {
                _context12.n = 2;
                break;
              }
              _context12.n = 1;
              return this.processTransferQueue();
            case 1:
              return _context12.a(2);
            case 2:
              _i4 = 0, _arr3 = ['outbound_broadcast', 'outbound_confirmed'];
            case 3:
              if (!(_i4 < _arr3.length)) {
                _context12.n = 14;
                break;
              }
              status = _arr3[_i4];
              _t48 = _createForOfIteratorHelper;
              _context12.n = 4;
              return this.mod.database.getTransfers({
                status: status
              });
            case 4:
              _iterator20 = _t48(_context12.v);
              _context12.p = 5;
              _iterator20.s();
            case 6:
              if ((_step20 = _iterator20.n()).done) {
                _context12.n = 10;
                break;
              }
              row = _step20.value;
              if (row.outbound_tx_sig) {
                _context12.n = 7;
                break;
              }
              return _context12.a(3, 9);
            case 7:
              if (!(row.outbound_block_hash !== blockHash || Number(row.outbound_block_id) !== Number(blockId))) {
                _context12.n = 8;
                break;
              }
              return _context12.a(3, 9);
            case 8:
              _context12.n = 9;
              return this.mod.database.updateTransfer(row.id, {
                status: 'outbound_awaiting',
                outbound_block_id: null,
                outbound_block_hash: '',
                outbound_confirmation_block_id: null
              });
            case 9:
              _context12.n = 6;
              break;
            case 10:
              _context12.n = 12;
              break;
            case 11:
              _context12.p = 11;
              _t49 = _context12.v;
              _iterator20.e(_t49);
            case 12:
              _context12.p = 12;
              _iterator20.f();
              return _context12.f(12);
            case 13:
              _i4++;
              _context12.n = 3;
              break;
            case 14:
              if (longestChain) {
                _context12.n = 25;
                break;
              }
              _context12.n = 15;
              return (_this$mod$database$li2 = (_this$mod$database2 = this.mod.database).listStoreWithdrawalsInBlock) === null || _this$mod$database$li2 === void 0 ? void 0 : _this$mod$database$li2.call(_this$mod$database2, blockId, blockHash);
            case 15:
              withdrawals = _context12.v;
              _iterator21 = _createForOfIteratorHelper(withdrawals || []);
              _context12.p = 16;
              _iterator21.s();
            case 17:
              if ((_step21 = _iterator21.n()).done) {
                _context12.n = 22;
                break;
              }
              _row9 = _step21.value;
              _context12.p = 18;
              _context12.n = 19;
              return this.mod.database.updateTransfer(_row9.id, {
                inbound_longest_chain: 0,
                inbound_block_id: null,
                inbound_block_hash: '',
                inbound_confirmation_block_id: null,
                inbound_confirmations: 0
              });
            case 19:
              _context12.n = 21;
              break;
            case 20:
              _context12.p = 20;
              _t50 = _context12.v;
              console.error('Mixin store withdrawal reorganization was not recorded', {
                transfer_id: _row9.id,
                inbound_tx_sig: _row9.inbound_tx_sig,
                error: (_t50 === null || _t50 === void 0 ? void 0 : _t50.message) || String(_t50)
              });
            case 21:
              _context12.n = 17;
              break;
            case 22:
              _context12.n = 24;
              break;
            case 23:
              _context12.p = 23;
              _t51 = _context12.v;
              _iterator21.e(_t51);
            case 24:
              _context12.p = 24;
              _iterator21.f();
              return _context12.f(24);
            case 25:
              _context12.n = 26;
              return this.processTransferQueue();
            case 26:
              return _context12.a(2);
          }
        }, _callee11, this, [[18, 20], [16, 23, 24, 25], [5, 11, 12, 13]]);
      }));
      function onChainReorganization(_x12, _x13, _x14) {
        return _onChainReorganization.apply(this, arguments);
      }
      return onChainReorganization;
    }()
  }]);
}();
module.exports = Transfers;